var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBsrmLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.62598 24.5215C6.62598 24.5215 11.0716 14.5883 25.5852 14.8065C25.5852 14.8065 33.8297 15.102 39.2082 20.943C39.2082 20.943 38.0031 24.0288 36.5825 25.4328C36.5825 25.4328 33.3632 20.4152 23.5638 20C21.5407 19.9815 19.5366 20.3895 17.6832 21.1973C15.8298 22.0051 14.1691 23.1944 12.8102 24.6868C12.8102 24.6868 15.6373 28.9092 22.7651 29.9894C23.3341 32.3364 25.207 35.0704 25.207 35.0704C25.207 35.0704 11.3614 34.4194 6.62598 24.5215Z",
    fill: "url(#paint0_linear_235_496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.2634 20.0211C22.2634 20.0211 20.288 27.9697 25.1753 35.1091C30.0626 42.2484 39.0422 44.4828 42.6291 43.9937C42.6291 43.9937 48.4599 35.9747 42.9824 24.5813C41.954 26.4402 40.6292 28.1205 39.0598 29.5567C39.0598 29.5567 41.0812 35.556 39.385 38.6418C36.2257 38.2899 32.1087 37.3434 28.9565 31.9916C28.9565 31.9916 26.5288 28.5468 27.6702 20.4363C25.8889 20.099 24.0755 19.9597 22.2634 20.0211Z",
    fill: "url(#paint1_linear_235_496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.4121 14.8065C24.4121 14.8065 30.084 5.86909 42.4666 5.21814C42.4666 5.21814 47.4564 12.8642 44.4208 21.9282C44.4208 21.9282 41.5301 31.3863 30.7236 34.4616C30.1515 33.7604 29.6183 33.0286 29.1263 32.2695C28.6691 31.5849 28.3222 30.8334 28.0979 30.0422C28.0979 30.0422 35.3706 28.8423 38.2295 22.9029C38.2295 22.9029 41.9754 17.0619 39.2084 10.8972C37.4669 11.0212 35.7718 11.5123 34.2353 12.3379C32.6988 13.1635 31.356 14.3048 30.296 15.6861C28.3874 15.1125 26.4057 14.8162 24.4121 14.8065Z",
    fill: "url(#paint2_linear_235_496)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_496",
    x1: 6.67545,
    y1: 28.6242,
    x2: 41.3679,
    y2: 21.0214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_235_496",
    x1: 27.2921,
    y1: 39.0781,
    x2: 36.2842,
    y2: 26.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_235_496",
    x1: 46.9582,
    y1: 12.4032,
    x2: 30.7466,
    y2: 22.1729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsrmLogo2);
export default __webpack_public_path__ + "static/media/bsrm-logo-2.3bba9ad976101bc5a8b14f31bf8f55fb.svg";
export { ForwardRef as ReactComponent };